import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from 'context/AppContext';
import person_img from 'images/drawer/person_img.svg';

const UserDetailsHeader = (props) => {
    let appContext = useContext(AppContext);

    let userImg;
    if (appContext.userImg !== null) {
        userImg = appContext.userImg;
    } else {
        userImg = person_img;
    }

    return (
        <>
            <div className="header">
                <div className="left-side">
                    {props.userImg !== null ? (
                        <img
                            style={{
                                marginBottom: '10px',
                                height: '60px',
                                width: '60px',
                                borderRadius: '50%',
                                backgroundImage: `url(${userImg})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                            }}
                        />
                    ) : (
                        <div className="person-img"></div>
                    )}
                    <div
                        className="change-photo"
                        onClick={() => {
                            props.showDrawerEditAccount();
                        }}
                    >
                        Edit Photo
                    </div>
                </div>
                <div className="right-side">
                    <div className="name">
                        {appContext.defaults.first_name}{' '}
                        {appContext.defaults.last_name}
                    </div>
                    <div
                        className="sing-out"
                        onClick={appContext.logOut}
                        style={{ cursor: 'pointer' }}
                    >
                        Log Out
                    </div>
                </div>
                <div className="version-side">
                    {appContext.defaults.sub_is_active ? (
                        <div className="version-img-pro"></div>
                    ) : (
                        <div className="version-img-lite"></div>
                    )}
                </div>
            </div>
        </>
    );
};

export default UserDetailsHeader;
